import { BaseApiRouteService } from "mrb/core";

class AppVersionInfoApiRouteService extends BaseApiRouteService {
    find(filter) {
        return super.find(`${this.base}{?searchQuery,page,rpp,sort}`, filter);
    }

    getLatest() {
        return super.create(`${this.base}/latest`);
    }

    enable(id) {
        return super.update(`${this.base}/{id}/enable`, { id });
    }

    disable(id) {
        return super.update(`${this.base}/{id}/disable`, { id });
    }
}

export default AppVersionInfoApiRouteService;
